module.exports = new __parcel__URL__("Logistiek.dfffab55.jpg").toString();